import { useEffect } from 'react';

/**
 * Adds a class to <body> while the component is mounted (and removes it after).
 * Used to reproduce the original templates' `<body class="sign-in">`, so the
 * page background fills the whole viewport (body/html backgrounds paint the
 * canvas; a div's background does not).
 */
export function useBodyClass(className: string) {
  useEffect(() => {
    document.body.classList.add(className);
    return () => document.body.classList.remove(className);
  }, [className]);
}
